module.exports = __webpack_public_path__ + "static/media/TXT.4eda8a34.svg";